import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, formatValueByType, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerMessageTypeByTimeChart = ({ data, influencerLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.influencerId], influencerLabelMap)[0],
        data: item.manualEarnings || [],
        mainFlowEarnings: item.mainFlowEarnings || [],
        manualEarnings: item.manualEarnings || [],
        massDmEarnings: item.massDmEarnings || [],
        totalEarnings: item.totalEarnings || [],
      })),
    }),
    [data, influencerLabelMap, dateRange],
  );

  const tooltipFormatter = useMemo(
    () =>
      function () {
        const pointIndex = this.point.index;
        const seriesOptions = this.series.userOptions;
        let tooltipText = `<b>${this.point.category}</b><br/>`;
        const markerStyle = `<span style="color:${this.color}">\u25CF</span>`;

        tooltipText += `${markerStyle} ${this.series.name}<br/><br/>`;
        tooltipText += `Main Flow: ${formatValueByType(seriesOptions.mainFlowEarnings?.[pointIndex], 'currency')}<br/>`;
        tooltipText += `Manual: ${formatValueByType(seriesOptions.manualEarnings?.[pointIndex], 'currency')}<br/>`;
        tooltipText += `Mass DM: ${formatValueByType(seriesOptions.massDmEarnings?.[pointIndex], 'currency')}<br/>`;
        tooltipText += `<br/><b>Total: ${formatValueByType(seriesOptions.totalEarnings?.[pointIndex], 'currency')}</b><br/>`;

        return tooltipText;
      },
    [],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Message Type Earnings Over Time"
      subtitle="Manual earnings trend for the selected creators."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more creators to load message type earnings."
      tooltipFormatter={tooltipFormatter}
      tooltipShared={false}
    />
  );
};

export default OrganizationInfluencerMessageTypeByTimeChart;
